import { PressEvent } from '@react-types/shared';
import { UnstyledButton } from '@sparemin/blockhead';
import cn from 'classnames';

import PlaybackButton, { PlaybackButtonProps } from '../PlaybackButton';
import styles from './CondensedPlaybackButton.module.scss';
import CondensedPlaybackButtonAria, {
  CondensedPlaybackButtonAriaProps,
} from './CondensedPlaybackButtonAira';

export type PlaybackIconProps = Pick<
  PlaybackButtonProps,
  'loading' | 'size' | 'status'
> & {
  onClick?: (e: PressEvent) => void;
};

export type Icon = React.ComponentType<PlaybackButtonProps>;

export interface CondensedPlaybackButtonProps
  extends PlaybackIconProps,
    Pick<CondensedPlaybackButtonAriaProps, 'ariaVideoTitle'> {
  className?: string;
  icon?: Icon;
  disabled?: boolean;
}

const CondensedPlaybackButton: React.FC<CondensedPlaybackButtonProps> = ({
  ariaVideoTitle,
  className,
  icon: Icon = PlaybackButton,
  disabled,
  loading,
  onClick,
  size,
  status,
}) => (
  <UnstyledButton
    className={cn(styles.button, className)}
    isDisabled={disabled}
    onPress={onClick}
  >
    <CondensedPlaybackButtonAria
      isLoading={loading}
      {...{ ariaVideoTitle, status }}
    />
    <div>
      <Icon {...{ disabled, loading, size, status }} />
    </div>
  </UnstyledButton>
);

export default CondensedPlaybackButton;
